import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Speed is a promise.",
    body: "Anyone can quote a transit time. We build the redundancies that keep it — backup capacity on every lane, recovery plans drafted before disruption ever happens.",
  },
  {
    n: "02",
    title: "Borders are solvable.",
    body: "Tariffs, paperwork, inspections. Friction is a logistics problem, and logistics problems are exactly what we exist to eliminate.",
  },
  {
    n: "03",
    title: "Visibility is everything.",
    body: "Every container, pallet and parcel reports its position in real time. You never chase an update — the data comes to you.",
  },
];

export function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="scroll-mt-20 border-t border-white/10 bg-[#0a0a0a] px-6 py-28 lg:px-12 lg:py-40"
    >
      <Reveal>
        <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-white/50">
          <span className="h-px w-10 bg-[#FF3B30]" />
          The manifesto
        </p>
      </Reveal>

      <div className="mt-16 lg:mt-24">
        {CHAPTERS.map((chapter, i) => (
          <Reveal key={chapter.n} delay={0.08 * i}>
            <div className="grid gap-6 border-t border-white/10 py-14 lg:grid-cols-12 lg:items-center lg:gap-10 lg:py-20">
              <div className="lg:col-span-5">
                <span
                  className="text-outline-red block font-display text-8xl font-extralight leading-none lg:text-[11rem]"
                  data-testid={`manifesto-number-${chapter.n}`}
                >
                  {chapter.n}
                </span>
              </div>
              <div className="lg:col-span-7">
                <h3 className="font-display text-3xl font-medium uppercase tracking-tight sm:text-4xl lg:text-5xl">
                  {chapter.title}
                </h3>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
                  {chapter.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
